import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { NycdIndexCardStackBackgroundViewModel } from './nycd-index-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-nycd-index-card-background',
  templateUrl: './nycd-index-card-stack-background.component.html',
  styleUrls: ['./nycd-index-card-stack-background.component.scss'],
  providers: [NycdIndexCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NycdIndexCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: NycdIndexCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
